<template>

  <div>
    <van-form @submit="onSubmit" ref="ruleForm"  class="login-bg">
      <template v-if="!next">
        <van-field v-model.trim="phone" label="手机号"  placeholder="请输入手机号" />
        <van-field  v-model.trim="sms"  center  clearable   label="短信验证码"  placeholder="请输入短信验证码">
            <template #button>
              <van-button size="small" type="primary" color="#029FD1" :disabled="time < 61  " @click.prevent="send">{{time > 60 ?  '发送验证码':time + '秒'}}</van-button>
            </template>
        </van-field>
      </template>
      <template v-else>
          <van-field v-model.trim="password1"   type="password"  label="新密码"  placeholder="请设置新密码" />
          <van-field v-model.trim="password2"   type="password"  label="确认密码"  placeholder="请再次输入新密码" />
      </template>
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" :disabled="disabled" color="#029FD1">{{next ?"修改":"下一步"}}</van-button>
    </div>
    </van-form>
  </div>

</template>

<script>

export default {
  name: 'login',
  data () {
    return {
      phone:'',
      sms:'',
      password1:'',
      password2:'',
      next:false,
      time:61,
    }
  },
  computed:{
    disabled(){
      if (this.next) {
         return !( this.password1 && this.password2)
      }else {
        return  !(this.phone && this.sms)
     }
    }
  },
  created(){
    // 注入手持机函数
    console.log();

  },
  methods: {
    // 发送验证码
    send(){
      let timer = null
      if(/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(this.phone)){
          timer =  setInterval(() => {
            if (this.time === 0  )  {
              clearInterval(timer)
              this.time = 61
            }else {
              this.time = this.time -1
            }
          }, 1000);
      }else {
        this.$dialog.alert({
        title: '提示',
        message: '请输入11位手机号',
        })
      }
    },

    // 获取验证码和修改密码
    onSubmit() {
     if (this.next) {
        // 修改密码
        if (this.password1 === this.password2) {
          this.$dialog.alert({
          title: '提示',
          message: '修改成功!',
          }).then( () => {
               this.$router.push({path:"/login"})
          })
        } else {
          this.$dialog.alert({
          title: '提示',
          message: '两次输入密码不一致!',
          })
        }
     }else {
        // 下一步
       if(!/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(this.phone) ){
          this.$dialog.alert({
          title: '提示',
          message: '请输入11位手机号',
          })
      }else if(!/^[0-9]{6}$/.test(this.sms)) {
          this.$dialog.alert({
          title: '提示',
          message: '请输入6位数字的验证码',
          })
      } else {
        this.next = true
      }
     }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.login-bg {
  margin: 20px 0 ;
}


</style>



// WEBPACK FOOTER //
// src/components/password.vue